import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { useWorkspace } from '@/api/workspace'
import { PoolForm } from '@/components/materials/pool-form'

// Pool create (UI-SCREENS M-02, #64). Owner only; the API refuses Staff too.
export const Route = createFileRoute('/w/$slug/materials/pools/new')({
  component: NewPool,
  staticData: { breadcrumb: 'materials.form.newTitle' },
})

function NewPool() {
  const { t } = useTranslation()
  const { slug } = Route.useParams()
  const workspace = useWorkspace(slug)

  if (workspace.data && workspace.data.role !== 'owner') {
    return <Navigate to="/w/$slug/materials" params={{ slug }} replace />
  }

  return (
    <section className="flex flex-col gap-4">
      <h1 className="font-heading text-xl font-semibold">{t('materials.form.newTitle')}</h1>
      <PoolForm slug={slug} />
    </section>
  )
}
